import React, { useEffect } from "react";
import AnimationCommon from "../common/AnimationCommon";
import { Link } from "react-router-dom";

const DownloadPage = () => {
  useEffect(() => {
    document.body.classList.remove("inner-page");
  }, []);
  return (
    <section className='auth-page'>
      <AnimationCommon />
      <div className='download'>
        <img src='assets/images/other-page/down.png' alt='down' className='img-fluid icon' />
        <h3>Your download should begin automatically</h3>
        <h4>
          If it doesn’t start automatically,{" "}
          <Link to={`${process.env.PUBLIC_URL}/home`} className='manual-down text-decoration-none'>
            please click here to downlaod manually.
          </Link>
        </h4>
        <Link to={`${process.env.PUBLIC_URL}/home`}>
          <img src='assets/images/title-logo.png' alt='logo' className='mt-3' />
        </Link>
      </div>
    </section>
  );
};

export default DownloadPage;
